module.exports = __webpack_public_path__ + "static/media/why_sl.b66f9eae.vtt";